export default __webpack_public_path__ + "assets/images/flakers_95f373a9b8267475ff7efb9c130bdede.png";